<template>
<el-dialog :title="!dataForm.userId ? '新增' : '新增合约'" :close-on-click-modal="false" :visible.sync="visible">
    <el-form :model="dataForm" label-position="right" :rules="dataRule" ref="dataForm" :inline="true" style="margin-left: 5%">
        <el-form-item label="姓名" prop="realName">
            <el-input disabled v-model="dataForm.realName" style="width: 200px" placeholder="真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="全部课时(课包课时+赠送课时)" prop="courseAllNum">
            <el-input-number disabled v-model="dataForm.courseAllNum" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="课包类型" prop="courseClassType">
            <el-select v-model="dataForm.courseClassType" placeholder="请选择课包类型">
                <el-option label="常规课" value="NORMAL"></el-option>
                <el-option label="营队课" value="CAMP"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="是否体验课" prop="experienceClass" v-if="dataForm.courseClassType=='NORMAL'">
            <el-switch v-model="dataForm.experienceClass"  controls-position="right"></el-switch>
        </el-form-item>
        <el-form-item label="课包课时" prop="courseActualNum">
            <el-input-number v-model="dataForm.courseActualNum" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="已上课时" prop="consumeCourseNum">
            <el-input-number v-model="dataForm.consumeCourseNum" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="剩余课时" prop="courseLimit">
            <el-input-number disabled v-model="dataForm.courseLimit" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="缴费金额" prop="totalAmount">
            <el-input-number v-model="dataForm.totalAmount" controls-position="right" :min="0"></el-input-number>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
            <el-input v-model="dataForm.remark" type="textarea" style="width: 780px" placeholder="请输入课包备注"></el-input>
        </el-form-item>
        <el-form-item label="是否赠课" prop="delivery">
            <el-switch v-model="dataForm.delivery" controls-position="right"></el-switch>
        </el-form-item>
        <el-form-item label="赠送课时" prop="deliveryNum">
            <el-input-number :disabled="deliverystate" v-model="dataForm.deliveryNum" :min="0" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="合约日期" prop="contractDate">
            <el-date-picker v-model="dataForm.contractDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期">
            </el-date-picker>
        </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
        <span style="margin-right: 300px; font-size: xx-small"><span style="color: red">注意事项</span>: 您的操作将会被记录在【系统-合约明细】中! 请核对后操作</span>
        <el-button @click="visible = false">取消</el-button>
        <el-button type="primary" @click="dataFormSubmit()" :loading="loading">确定</el-button>
    </span>
</el-dialog>
</template>

<script>
export default {
    data() {
        return {
            visible: false,
            loading: false,
            deliverystate: true,
            dataForm: {
                userId: undefined,
                courseClassType: '',
                realName: undefined,
                courseAllNum: 0,
                consumeCourseNum: undefined,
                courseActualNum: undefined,
                courseLimit: undefined,
                remark: undefined,
                contractDate: undefined,
                delivery: false,
                experienceClass: false,
                deliveryNum: 0,
                totalAmount: undefined
            },
            dataRule: {
                courseLimit: [{
                    required: true,
                    message: "剩余课时不能为空",
                    trigger: "blur"
                }, ],
                courseActualNum: [{
                    required: true,
                    message: "课包课时不能为空",
                    trigger: "blur"
                }, ],
                consumeCourseNum: [{
                    required: true,
                    message: "已上课时不能为空",
                    trigger: "blur"
                }, ],
                remark: [{
                    required: true,
                    message: "备注不能为空",
                    trigger: "blur"
                }, ],
                courseClassType: [{
                    required: true,
                    message: "类型不能为空",
                    trigger: "blur"
                }, ],
                totalAmount: [{
                    required: true,
                    message: "缴费金额不能为空",
                    trigger: "blur"
                }, ],
                contractDate: [{
                    required: true,
                    message: "合约日期不能为空",
                    trigger: "blur"
                }, ],
            },
        };
    },
    computed: {
        newValue1() {
            return this.dataForm.courseActualNum
        },
        newValue2() {
            return this.dataForm.deliveryNum
        },
        newValue3() {
            return this.dataForm.consumeCourseNum
        },
        newDeliveryValue() {
            return this.dataForm.delivery
        },
        newValue4() {
            return this.dataForm.courseClassType
        }
    },
    watch: {
        newValue4(){
            if(this.dataForm.courseClassType == "CAMP"){
                this.dataForm.experienceClass = false
            }
        },
        newValue1() {
            if (this.dataForm.courseActualNum || this.dataForm.courseActualNum == 0) {
                this.dataForm.courseAllNum = this.dataForm.deliveryNum + this.dataForm.courseActualNum
                this.dataForm.courseLimit = this.dataForm.courseAllNum - this.dataForm.consumeCourseNum
            }
        },
        newValue3() {
            if (this.dataForm.consumeCourseNum || this.dataForm.consumeCourseNum === 0) {
                this.dataForm.courseAllNum = this.dataForm.deliveryNum + this.dataForm.courseActualNum
                this.dataForm.courseLimit = this.dataForm.courseAllNum - this.dataForm.consumeCourseNum
            }
        },
        newValue2() {
            if (this.dataForm.deliveryNum || this.dataForm.deliveryNum == 0) {
                this.dataForm.courseAllNum = this.dataForm.deliveryNum + this.dataForm.courseActualNum
                this.dataForm.courseLimit = this.dataForm.courseAllNum - this.dataForm.consumeCourseNum
            }
        },
        newDeliveryValue() {
            if (this.dataForm.delivery) {
                this.deliverystate = false
            } else {
                this.deliverystate = true
                this.dataForm.deliveryNum = 0
            }
        }
    },
    methods: {
        init(userId) {
            this.dataForm.userId = userId;
            this.visible = true;
            this.$nextTick(() => {
                this.$refs["dataForm"].resetFields();
                if (this.dataForm.userId) {
                    this.$http({
                        url: this.$http.adornUrl(`sys/user/info/${this.dataForm.userId}`),
                        method: "get",
                    }).then(({
                        data
                    }) => {
                        if (data && data.code === 0) {
                            this.dataForm.realName = data.user.realName;
                            this.dataForm.userId = data.user.userId;
                        }
                    });
                }
            });
        },
        // 表单提交
        dataFormSubmit() {
            if (this.dataForm.courseAllNum < 0) {
                this.$message.error("全部课时不能小于0！");
                return
            }
            this.$refs["dataForm"].validate((valid) => {

                if (valid) {
                    this.loading = true;
                    this.$http({
                            url: this.$http.adornUrl(`/sys/user/updateCourseNum`),
                            method: `put`,
                            data: this.$http.adornData(this.dataForm),
                        })
                        .then(({
                            data
                        }) => {
                            if (data && data.code === 0) {
                                this.$message({
                                    message: "更新成功",
                                    type: "success",
                                });
                                this.visible = false;
                                this.$emit("refreshDataList");
                            } else {
                                this.$message.error(data.msg);
                            }
                            this.loading = false;
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            });
        },
    }
};
</script>
